var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H3.5C4.32843 0 5 0.671573 5 1.5V14.5C5 15.3284 4.32843 16 3.5 16H1.5C0.671573 16 0 15.3284 0 14.5V1.5Z",
    fill: "#FF3200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.5C7 0.671573 7.67157 0 8.5 0H10.5C11.3284 0 12 0.671573 12 1.5V14.5C12 15.3284 11.3284 16 10.5 16H8.5C7.67157 16 7 15.3284 7 14.5V1.5Z",
    fill: "#FF3200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.5C14 0.671573 14.6716 0 15.5 0H17.5C18.3284 0 19 0.671573 19 1.5V14.5C19 15.3284 18.3284 16 17.5 16H15.5C14.6716 16 14 15.3284 14 14.5V1.5Z",
    fill: "#FF3200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleTable);
export default __webpack_public_path__ + "static/media/vehicleTable.65c04ea3.svg";
export { ForwardRef as ReactComponent };